<template>
    <div class="w-full bg-white">
        <div class="w-full h-16 bg-brand-lightest">
            <ul class="h-full flex">
                <li class="mx-6 flex flex-row">
                    <router-link :to="{name: 'subscription', params: {vault_id: $route.params.vault_id}}" 
                        active-class="border-brand" 
                        class="flex items-center py-4 border-b-4 border-transparent hover:border-brand no-underline text-grey-darkest uppercase block text-center md:text-left text-xs md:text-base">
                        Subscription
                    </router-link>
                </li>
                <li class="mx-6 flex flex-row">
                    <router-link :to="{name: 'invoices', params: {vault_id: $route.params.vault_id}}" 
                        active-class="border-brand"  
                        class="flex items-center py-4 border-b-4 border-transparent hover:border-brand no-underline text-grey-darkest uppercase block text-center md:text-left text-xs md:text-base">
                        Invoices
                    </router-link>
                </li>
            </ul>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {  
}
</script>

<style>

</style>
